import React from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./sales.module.css";
import TabsC from "common/Tabs";
import Orders from "components/Sales/Orders";
import InstallmentOrders from "components/Sales/InstallmentOrders";
import RefundRequest from "components/Sales/RefundRequest";
import ApprovedRequest from "components/Sales/ApprovedRequest";
import DeniedRequest from "components/Sales/DeniedRequest";
import ContainerHeader from "common/ContainerHeader";

const TAB_KEYS = ["orders", "installments"];

const Sales = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const selectedIndex = Math.max(0, TAB_KEYS.indexOf(tabParam));

  const setSelectedIndex = (index) => {
    const next = new URLSearchParams(searchParams);
    if (index > 0 && TAB_KEYS[index]) {
      next.set("tab", TAB_KEYS[index]);
    } else {
      next.delete("tab");
    }
    setSearchParams(next, { replace: true });
  };

  const Tabs = [
    { label: "Orders" },
    { label: "Installment Orders" },
    // { label: "Request Refund" },
    // { label: "Approved Refund" },
    // { label: "Denied Refunds" },
  ];

  const TabContent = [
    { content: <Orders /> },
    { content: <InstallmentOrders /> },
    // { content: <RefundRequest /> },
    // { content: <ApprovedRequest /> },
    // { content: <DeniedRequest /> },
  ];

  return (
    <>
          <ContainerHeader label="Sales " showAddButton={false} />
      <div className={styles.container}>
        <TabsC
          TabList_={Tabs}
          TabContent_={TabContent}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          TabListStyleOverride={styles.TabListStyleOverride}
        />
      </div>
      </>

  );
};

export default Sales;
